/* @ngInject */
function AssetPackController ($scope, $state) {
  $scope.assetPackId = $state.params.assetPackId
  $scope.type = $state.current.data.type
}

export { AssetPackController }
